
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator"
import SubCategorySearchForm from "@/components/Article/SubCategorySearchForm.vue"
import { mapActions } from "vuex"
import { SubCategory } from "types/subCategory"
import { DataTableHeader } from "vuetify/types"

type ID = number
interface SubCategoryWithSelect
  extends Pick<SubCategory["data"], "id" | "name" | "category"> {
  select?: boolean
}

@Component({
  components: { SubCategorySearchForm },
  methods: {
    ...mapActions("article", ["updateArticle"]),
  },
})
export default class SelectSubCategories extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "選択", value: "select", sortable: false },
      { text: "カテゴリー", value: "categoryName" },
      { text: "名前", value: "name" },
    ]
  }

  @Prop()
  public dialog!: boolean

  private subCategories: SubCategoryWithSelect[] = []
  private loading = false
  private totalPages = 0
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }
  private candidateMap: Map<ID, SubCategoryWithSelect> = new Map()

  public clear(): void {
    this.subCategories = []
    this.resetPagination()
    this.resetSelection()
    const form = this.$refs.subCategorySearchForm as InstanceType<
      typeof SubCategorySearchForm
    >
    form.reset()
  }

  public searchResult(
    result: SubCategoryWithSelect[],
    totalPages: number
  ): void {
    this.subCategories = result
    this.totalPages = totalPages
    this.modifySelection(this.subCategories)
    this.loading = false
  }

  public customSort(items: SubCategory["data"][]): SubCategory["data"][] {
    items.sort((a, b) => {
      if (a.category.priority < b.category.priority) {
        return 1
      } else if (a.category.priority > b.category.priority) {
        return -1
      } else if (a.order < b.order) {
        return -1
      } else if (a.order > b.order) {
        return 1
      } else {
        return 0
      }
    })
    return items
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private resetSelection() {
    this.candidateMap.clear()
  }

  @Watch("dialog")
  private init() {
    if (this.dialog) {
      this.onChangePage()
    }
  }

  @Watch("pagination.page", { deep: true })
  private onChangePage() {
    this.loading = true
    const subCategorySearchForm = this.$refs
      .subCategorySearchForm as InstanceType<typeof SubCategorySearchForm>
    const page = this.pagination.page
    const sortBy = this.pagination.sortBy[0]
    const descending = this.pagination.sortDesc[0]
    subCategorySearchForm.search(page, sortBy, descending)
    this.loading = false
  }

  @Emit("ok")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private ok(subCategories: SubCategoryWithSelect[]) {
    /** */
  }

  @Emit("cancel")
  private cancel() {
    /** */
  }

  private selected() {
    return Array.from(this.candidateMap.values())
  }

  private toggleCandidateSubCategory(subCategory: SubCategoryWithSelect) {
    if (subCategory.select) {
      this.candidateMap.set(subCategory.id, subCategory)
    } else {
      this.candidateMap.delete(subCategory.id)
    }
  }

  private modifySelection(subCategories: SubCategoryWithSelect[]) {
    subCategories.forEach((subCategory) => {
      Object.assign(subCategory, {
        select: this.candidateMap.has(subCategory.id),
      })
    })
  }
}
